import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-start-over-dialog',
  templateUrl: './confirm-start-over-dialog.component.html',
  styleUrls: ['./confirm-start-over-dialog.component.scss'],
  standalone: false,
})
export class ConfirmStartOverDialogComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
